import { createSolidTexture2D } from '../../texture/solid-texture.js';
import { _installPbrFallbackResolver } from './pbr-pipeline.js';
import { _getPbrExts } from './pbr-flags.js';
import { PBR_HAS_EMISSIVE, PBR_HAS_NORMAL_MAP, PBR_HAS_ALPHA_BLEND, PBR_HAS_SPEC_GLOSS, PBR_HAS_DOUBLE_SIDED, PBR2_HAS_UV2, PBR2_HAS_BASE_COLOR_FACTOR, PBR_HAS_OCCLUSION, PBR_HAS_SPECULAR_AA } from './pbr-flag-bits.js';

let _pbrGroupBuilder = null;
function getPbrGroupBuilder() {
  if (_pbrGroupBuilder) {
    return _pbrGroupBuilder;
  }
  const builder = async (scene, meshes) => {
    const envTex = scene._envTextures;
    const renderableMod = await import('./pbr-renderable.js');
    const result = await renderableMod.buildPbrRenderables(scene, meshes, envTex);
    builder._rebuildSingle = result.rebuildSingle;
    return result;
  };
  builder._materialFamily = "pbr";
  return _pbrGroupBuilder = builder;
}
function _computePbrMaterialFeatures(mat) {
  let features = (mat.emissiveTexture ? PBR_HAS_EMISSIVE : 0) | (mat.normalTexture ? PBR_HAS_NORMAL_MAP : 0) | (mat.alphaBlend === true || (mat._alphaCutOff ?? 0) <= 0 && mat.alpha < 1 ? PBR_HAS_ALPHA_BLEND : 0) | (mat.specGlossTexture ? PBR_HAS_SPEC_GLOSS : 0) | (mat.doubleSided ? PBR_HAS_DOUBLE_SIDED : 0);
  if ((mat.occlusionStrength ?? 1) > 0) {
    features |= PBR_HAS_OCCLUSION;
  }
  if (mat.enableSpecularAA) {
    features |= PBR_HAS_SPECULAR_AA;
  }
  let features2 = 0;
  for (const ext of _getPbrExts().values()) {
    if (ext.detect) {
      const d = ext.detect(mat);
      features |= d.f;
      features2 |= d.f2;
    }
  }
  if (mat._uv2Mask) {
    features2 |= PBR2_HAS_UV2;
  }
  if (mat.baseColorFactor) {
    features2 |= PBR2_HAS_BASE_COLOR_FACTOR;
  }
  return { features, features2 };
}
function createPbrMaterial(props) {
  _installPbrFallbackResolver((engine) => engine._pbrFallbackTex ??= createSolidTexture2D(engine, 1, 1, 1));
  return {
    ...props,
    _buildGroup: getPbrGroupBuilder(),
    _uboVersion: 0
  };
}
function collectPbrBoundTextures(mat) {
  const t = [];
  for (const tex of [mat.baseColorTexture, mat.normalTexture, mat.ormTexture, mat.occlusionTexture, mat.emissiveTexture, mat.specGlossTexture]) {
    if (tex) {
      t.push(tex);
    }
  }
  for (const ext of _getPbrExts().values()) {
    ext.textures?.(mat, t);
  }
  return t;
}

export { _computePbrMaterialFeatures, collectPbrBoundTextures, createPbrMaterial, getPbrGroupBuilder };
//# sourceMappingURL=pbr-material.js.map
